<div class="folder-title show-folder title">
  <div
    class="flex max-w-full items-center gap-1 overflow-hidden text-ellipsis whitespace-nowrap leading-[3rem]">
    @if (
      (isInbox && isAnyFolders && !isAllFoldersSelected) ||
      (!isInbox && isAnyFolders && !isAllFoldersSelected)
    ) {
      {{
        currentFolder?.creationType === 1
          ? ('folderType' + currentFolder?.folderType | translate)
          : currentFolderName
      }}
    }
    @if (isAnyFolders && isAllFoldersSelected) {
      {{ 'allFoldersLabel' | translate }}
    }
    <span
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
      class="material-symbols-outlined cursor-default text-[18px]"
      [ngClass]="showArchiveInfo ? '' : 'hidden'"
      (mouseenter)="isOpen = true">
      shield_question
    </span>
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="positions"
  (detach)="isOpen = false"
  (overlayOutsideClick)="isOpen = false">
  <div
    class="overlay-tooltip flex w-full min-w-[200px] flex-col rounded-sm bg-[#424242] px-4 py-2 text-[12px] text-white"
    (mouseleave)="isOpen = false">
    <div class="mb-1 font-bold">{{ 'archiveSettings' | translate }}:</div>
    <div class="flex items-center justify-between">
      <span>{{ 'organization' | translate }}</span>
      <mat-icon>
        {{ currentFolder?.organizationArchive ? 'check' : 'close' }}
      </mat-icon>
    </div>
    <div class="flex items-center justify-between">
      <span>{{ 'mailAccountLabel' | translate }}</span>
      <mat-icon>
        {{ currentFolder?.mailAccountArchive ? 'check' : 'close' }}
      </mat-icon>
    </div>
    <div class="flex items-center justify-between">
      <span>{{ 'mailFolderLabel' | translate }}</span>
      <mat-icon>
        {{ currentFolder?.mailFolderArchive ? 'check' : 'close' }}
      </mat-icon>
    </div>
  </div>
</ng-template>
